import { safeExecute } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Int32Field, BooleanField, StringField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class ValueRegionBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new ValueRegionBox({
            uuid,
            graph,
            name: "ValueRegionBox",
            pointerRules: {
                accepts: [Pointers.Selection, Pointers.Editing],
                mandatory: false,
            },
        }), constructor);
    }
    static ClassName = "ValueRegionBox";
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitValueRegionBox, this);
    }
    get regions() {
        return this.getField(1);
    }
    get events() {
        return this.getField(2);
    }
    get position() {
        return this.getField(10);
    }
    get duration() {
        return this.getField(11);
    }
    get loopOffset() {
        return this.getField(12);
    }
    get loopDuration() {
        return this.getField(13);
    }
    get mute() {
        return this.getField(14);
    }
    get label() {
        return this.getField(15);
    }
    get hue() {
        return this.getField(16);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "regions",
                pointerRules: NoPointers,
            }, Pointers.RegionCollection, true),
            2: PointerField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "events",
                pointerRules: NoPointers,
            }, Pointers.ValueEventCollection, true),
            10: Int32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "position",
                pointerRules: NoPointers,
            }),
            11: Int32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "duration",
                pointerRules: NoPointers,
            }),
            12: Int32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "loopOffset",
                pointerRules: NoPointers,
            }),
            13: Int32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "loopDuration",
                pointerRules: NoPointers,
            }),
            14: BooleanField.create({
                parent: this,
                fieldKey: 14,
                fieldName: "mute",
                pointerRules: NoPointers,
            }),
            15: StringField.create({
                parent: this,
                fieldKey: 15,
                fieldName: "label",
                pointerRules: NoPointers,
            }),
            16: Int32Field.create({
                parent: this,
                fieldKey: 16,
                fieldName: "hue",
                pointerRules: NoPointers,
            }),
        };
    }
}
